<div>
  @if (form) {
    <form class="mt-1" [formGroup]="form">
      <div class="mb-2" [class.mb-4]="form.get('facilityNotFound').value">
        <p
          class="mb-4 font-semibold"
          data-test-id="npi-not-found-message"
          >
          NPI was not found. To continue, please select the checkbox below and enter the Servicing Facility details.
        </p>
        <div class="flex items-center">
          <p-checkbox
            inputId="facilityNotFoundCheck"
            [binary]="true"
            formControlName="facilityNotFound"
            data-test-id="facility-not-found-checkbox"
          ></p-checkbox>
          <label for="facilityNotFoundCheck" class="ml-2">Facility Not Found</label>
        </div>
      </div>
      @if (form.get('facilityNotFound').value) {
        <div class="mb-4">
          <p-panel header="New Servicing Facility">
            <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
              <div class="col-span-12 md:col-span-6">
                <div class="field">
                  <label class="field-required">NPI:</label>
                  <div class="p-field-value">
                    <p-inputMask
                      data-test-id="npi-input"
                      formControlName="npi"
                      mask="9999999999"
                      slotChar=""
                      [autoClear]="false"
                    />
                      <errors-messages [control]="form.get('npi')"></errors-messages>
                    </div>
                  </div>
                  <div class="field">
                    <label class="field-required">Servicing Facility Name:</label>
                    <div class="p-field-value">
                      <input
                        type="text"
                        pInputText
                        trimInputValue
                        formControlName="facilityName"
                        data-test-id="facility-name-input"
                        />
                        <errors-messages [control]="form.get('facilityName')"></errors-messages>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-required">Tax ID:</label>
                      <div class="p-field-value">
                        <p-inputMask
                          data-test-id="tax-id-input"
                          formControlName="taxId"
                          mask="999999999"
                          slotChar=""
                          [autoClear]="false"
                        />
                          <errors-messages [control]="form.get('taxId')"></errors-messages>
                        </div>
                      </div>
                      <div class="field">
                        <label>Phone:</label>
                        <div class="p-field-value">
                          <p-input-mask
                            mask="(999) 999-9999"
                            formControlName="phone"
                            [unmask]="true"
                            [autoClear]="false"
                            data-test-id="phone-input"
                            >
                          </p-input-mask>
                          <errors-messages [control]="form.get('phone')"></errors-messages>
                        </div>
                      </div>
                      <div class="field">
                        <label>Fax:</label>
                        <div class="p-field-value">
                          <p-input-mask
                            mask="(999) 999-9999"
                            formControlName="fax"
                            [unmask]="true"
                            [autoClear]="false"
                            data-test-id="fax-input"
                            >
                          </p-input-mask>
                          <errors-messages [control]="form.get('fax')"></errors-messages>
                        </div>
                      </div>
                    </div>
                    <div class="col-span-12 md:col-span-6">
                      <div class="field">
                        <label>Street:</label>
                        <div class="p-field-value">
                          <input
                            type="text"
                            pInputText
                            trimInputValue
                            formControlName="address"
                            data-test-id="street-input"
                            />
                            <errors-messages [control]="form.get('address')"></errors-messages>
                          </div>
                        </div>
                        <div class="field">
                          <label>City:</label>
                          <div class="p-field-value">
                            <input
                              type="text"
                              pInputText
                              trimInputValue
                              formControlName="city"
                              data-test-id="city-input"
                              />
                              <errors-messages [control]="form.get('city')"></errors-messages>
                            </div>
                          </div>
                          <div class="field">
                            <label>State:</label>
                            <div class="p-field-value">
                              <p-select
                                [options]="states"
                                placeholder="Select"
                                formControlName="state"
                                data-test-id="state-dropdown"
                                >
                              </p-select>
                              <errors-messages [control]="form.get('state')"></errors-messages>
                            </div>
                          </div>
                          <div class="field">
                            <label>ZIP Code:</label>
                            <div class="p-field-value">
                              <p-input-mask
                                mask="99999?-9999"
                                formControlName="zipCode"
                                [unmask]="true"
                                [autoClear]="false"
                                data-test-id="zip-code-input"
                                >
                              </p-input-mask>
                              <errors-messages [control]="form.get('zipCode')"></errors-messages>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-panel>
                  </div>
                  <servicing-facility-contact-details
                    [contactDetails]="contactDetails"
                    [isExternal]="isExternalFlow"
                    (detailsUpdated)="setContactDetails($event)"
                  ></servicing-facility-contact-details>
                }
              </form>
            }
          </div>
